import { useQuery, UseQueryResult } from "react-query";
import Company from "../../../../domain/common/entities/Company";
import findCompany from "../../../../domain/common/useCases/findCompany";

export default function useGetCompany(): UseQueryResult<Company, Error> {
  return useQuery<Company, Error>(["company"], () => findCompany(), {
    initialData: undefined,
  });
}
